import React from 'react';
import {
  branch,
  renderComponent,
  compose,
  withHandlers,
  withProps,
} from 'recompose';
import { CartLoading } from '../loading';
import {
  Wrapper,
  AddActionButton,
  ManipulationButton,
  PlaceHolder,
} from './style';
import CartIcon from '../../images/cartIcon';
import { FlexRow } from '../misc';

const QuantityManipulator = ({
  onUpdateCartItem,
  onAddCartItem,
  itemInCart,
  qty,
}) => {
  return (
    <FlexRow
      css={`
        height: 45px;
      `}
    >
      {itemInCart ? (
        <Wrapper>
          <ManipulationButton
            left
            disabled={qty === 1 || qty === 0}
            onClick={() => onUpdateCartItem({ type: 'decrease' })}
          >
            -
          </ManipulationButton>
          <span>{qty}</span>
          <ManipulationButton
            right
            onClick={() => onUpdateCartItem({ type: 'increase' })}
          >
            +
          </ManipulationButton>
        </Wrapper>
      ) : (
        <AddActionButton onClick={() => onAddCartItem()}>
          <span>Zum</span>
          <CartIcon height={25} />
          <span>hinzufügen</span>
        </AddActionButton>
      )}
    </FlexRow>
  );
};

const spinnerWhileLoading = isLoading =>
  branch(
    isLoading,
    renderComponent(() => (
      <div
        css={`
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        <CartLoading />
      </div>
    ))
  );

const showPlaceHolderWhileLoading = isLoading =>
  branch(isLoading, renderComponent(() => <PlaceHolder />));

const enhance = compose(
  spinnerWhileLoading(props => {
    const { cartItemsStatus, articleID } = props;
    return cartItemsStatus && cartItemsStatus[articleID] === 'fetching';
  }),
  showPlaceHolderWhileLoading(props => {
    const { id, cartStatus } = props;
    return !id || cartStatus === 'fetching';
  }),
  withProps(ownProps => {
    const { items, articleID, id, cartStatus } = ownProps;
    const itemInCart =
      items.length && items.filter(item => item.articleID === articleID)[0];
    return {
      itemInCart,
      qty: itemInCart && itemInCart.qty,
      cartIsLoading: !id && cartStatus === 'fetching',
    };
  }),
  withHandlers(initialProps => {
    const { articleID, id } = initialProps;
    return {
      onUpdateCartItem: props => ({ type }) => {
        const { qty } = props;
        return props.onUpdateCartItem({
          id,
          articleID,
          qty: type === 'increase' ? qty + 1 : qty - 1,
        });
      },
      onAddCartItem: props => () => props.onAddCartItem({ id, articleID }),
    };
  })
);
export default enhance(QuantityManipulator);



// WEBPACK FOOTER //
// ./src/components/qtymanipulator/index.js